// Single source of truth for complexity classifications used on
// Leistungen-Seite, So-funktioniert's-Seite und Kalkulator-Kontext.

export const GRUENDUNG_TIERS = [
  {
    key: "einfach",
    label: "Einfach",
    summary: "Klarer Standardfall",
    bullets: [
      "Eine Gründer:in mit Schweizer Wohnsitz oder gültiger Aufenthaltsbewilligung",
      "GmbH oder Einzelfirma, klassische Branche (Handel, Dienstleistung, Beratung)",
      "Standardstatuten, Standardzweck, keine Sonderbewilligungen",
      "Eigenes Geschäftsdomizil vorhanden",
    ],
    effort: "ca. 1–2 Wochen vom Mandat bis Handelsregister-Eintrag",
  },
  {
    key: "standard",
    label: "Standard",
    summary: "Typischer DACH-Kunde",
    bullets: [
      "Gründer:in aus Deutschland / Österreich ohne Schweizer Wohnsitz",
      "GmbH oder AG, 1–3 Gesellschafter:innen",
      "Domiziladresse + Verwaltungsrats-Mandat über MBW",
      "Klärung Aufenthaltsstatus & Wegzugsbesteuerung Deutschland",
      "Übersetzung / Beglaubigung von Auslandsdokumenten",
    ],
    effort: "ca. 3–5 Wochen, abhängig von Apostille- & Bankterminen",
  },
  {
    key: "komplex",
    label: "Speziell / komplex",
    summary: "Struktur & Schutz",
    bullets: [
      "AG / Holding mit mehreren wirtschaftlich Berechtigten (UBOs)",
      "Strukturierte Verlagerung von Firmenwerten in die Schweiz",
      "Vermögensschutz – Trennung von Betriebs- und Privatvermögen",
      "Nachfolge- & Erbschaftsplanung grenzüberschreitend (DE / CH)",
      "Aktionärbindungsvertrag, Earn-Out, Vesting, Optionsprogramme",
      "Doppelbesteuerungsabkommen DE–CH gezielt nutzen",
    ],
    effort: "ca. 6–12 Wochen, individueller Fahrplan",
  },
];

export const STEUER_TIERS = [
  {
    key: "einfach",
    label: "Einfach",
    summary: "Saubere Routine",
    bullets: [
      "Schweizer Steuererklärung natürliche Person ohne Auslandsbezug",
      "GmbH / AG mit klassischer OR-Buchhaltung",
      "MWST-Abrechnung (effektiv oder Saldosatzmethode)",
      "Standardmäßige Quellensteuer & Verrechnungssteuer",
    ],
    effort: "wenige Tage pro Mandat / Jahr",
  },
  {
    key: "standard",
    label: "Standard",
    summary: "DE ↔ CH optimieren",
    bullets: [
      "Wegzug aus Deutschland in die Schweiz (§ 6 AStG, Wegzugsbesteuerung)",
      "Optimale Mischung aus Geschäftsführer-Lohn und Dividende",
      "Kapitaleinlagereserven & Verrechnungssteuer korrekt nutzen",
      "Privates Wertschriftenverzeichnis mit DE-Bezug",
      "Doppelbesteuerungsabkommen DE–CH in der Praxis anwenden",
    ],
    effort: "ca. 3–8 Beratungstage pro Jahr",
  },
  {
    key: "komplex",
    label: "Speziell / komplex",
    summary: "Vermögen sichern & vererben",
    bullets: [
      "Strukturierter Schutz von Geldwerten vor Zugriff in- und ausländischer Behörden",
      "Steueroptimierte Übertragung von Firmenwerten an die nächste Generation",
      "Erbschaft & Nachfolge grenzüberschreitend (DE / CH) – Stiftung, Trust, Schenkung",
      "Verkauf / Earn-Out / Beteiligungserlöse steuerlich strukturieren",
      "DBA-optimierte Holding- & Lizenzstrukturen",
      "Begleitung bei Selbstanzeige oder Vermögens-Konsolidierung",
    ],
    effort: "laufende Begleitung, individuell vereinbart",
  },
];
